var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":require("@/image/login/bg.png"),"alt":"","srcset":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }